import CardGiftProduct from '@/components/sections/builder/elements/body/cart-total/component/card-gift-product';
import { Skeleton } from '@/components/ui/skeleton';
import { ThemeColorSchemeType } from '@/stores/builder';
import { BaseFreeGift } from '@/stores/promotion';
import { BasePromotionRewardProduct } from '@/types/http/promotion/common';
import { Search } from 'lucide-react';

type TabProductGroupProps = {
  params: {
    page: number;
    pageSize: number;
    q: string;
  };
  isLoading: boolean;
  isRefetching: boolean;
  listRewardProduct: BasePromotionRewardProduct[];
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setSelectedProduct: React.Dispatch<React.SetStateAction<BasePromotionRewardProduct | undefined>>;
  selectedProducts: BaseFreeGift[];
  setSelectedTab: React.Dispatch<React.SetStateAction<'product_group' | 'product_variant'>>;
  colorScheme?: ThemeColorSchemeType;
};

export default function TabProductGroup({
  params,
  isLoading,
  isRefetching,
  listRewardProduct,
  handleSearch,
  setSelectedProduct,
  selectedProducts,
  setSelectedTab,
  colorScheme,
}: TabProductGroupProps) {
  return (
    <>
      <div
        className='relative w-full px-7'
        style={
          {
            '--background': colorScheme?.background || '#000000',
          } as React.CSSProperties
        }
      >
        <Search size={16} className='absolute left-9 top-1/2 -translate-y-1/2 text-gray-500' />
        <input
          type='text'
          placeholder='Search product ...'
          value={params.q}
          onChange={handleSearch}
          className='w-full rounded border py-2 pl-8 pr-3 text-sm outline-none ring-gray-200 focus:ring-1 focus:ring-[var(--background)]'
        />
      </div>
      <div className='mb-2 flex max-h-[400px] flex-col gap-3 overflow-y-auto px-7 py-2'>
        {isLoading || isRefetching ? (
          <div className='grid grid-cols-2 gap-3 overflow-y-auto lg:grid-cols-5'>
            {Array.from({ length: 10 }).map((_, idx) => (
              <Skeleton className='h-40 w-full' key={idx} />
            ))}
          </div>
        ) : (
          <div className='flex w-full flex-col gap-3'>
            {(listRewardProduct ?? []).length > 0 ? (
              <div className='grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'>
                {(listRewardProduct ?? []).map((product) => (
                  <CardGiftProduct
                    colorScheme={colorScheme}
                    key={product.product_group_id}
                    product={product}
                    setSelectedProduct={setSelectedProduct}
                    selectedProducts={selectedProducts}
                    setSelectedTab={setSelectedTab}
                  />
                ))}
              </div>
            ) : (
              <div className='flex w-full items-center justify-center py-10 text-sm text-gray-500'>
                No products found
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
